// extracted by mini-css-extract-plugin
export default {"facts__highlight":"rbXfSF4","facts__subline":"xeDk7nJ"};